<template>
  <div class="page">
    <BACK title="忘記密碼"/>
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item label="手機" prop="phone">
        <el-button class="input_note" @click="handleGetSMS" :disabled="delayTime" :class="delayTime ? 'delay' : ''">
          <template v-if="!showDelayText">
            <i class="el-icon-loading delay" v-if="delayTime"></i>
            <span v-else>傳送驗證碼</span>
          </template>
          <template v-else>
            <span class="delay">{{delayTimeText}}</span>
          </template>
        </el-button>
        <el-input type="number" oninput="value=value.replace(value.slice(10),'')" v-model="form.phone" placeholder="輸入手機號碼"></el-input>
      </el-form-item>
      <el-form-item label="重設密碼" prop="password">
        <el-input v-model="form.password" oninput="value=value.replace(value.slice(14),'')" type="password" clearable placeholder="輸入新密碼"></el-input>
      </el-form-item>
      <el-form-item label="確認密碼" prop="password2">
        <el-input v-model="form.password2" oninput="value=value.replace(value.slice(14),'')" type="password" clearable placeholder="再次輸入密碼"></el-input>
      </el-form-item>
      <el-form-item label="驗證碼" prop="vcode">
        <el-button class="input_btn input_nosms" @click="handleNoSMS">
          <span>沒收到驗證嗎?</span>
        </el-button>
        <el-input v-model="form.vcode" type="number" oninput="value=value.replace(value.slice(6),'')" clearable placeholder="輸入簡訊驗證碼"></el-input>
      </el-form-item>
    </el-form>
    <div class="btn">
      <el-button type="success" :disabled="loading" @click="beforeHandleSubmit()"><i class="el-icon-loading" v-if="loading"></i>送出</el-button>
    </div>
  </div>
</template>
<script>

import BACK from '@/components/back.vue'
import FN from '@/components/fn'
import { mapActions } from 'vuex'

export default {
  name: 'ForgotPassword',
  components: {
    BACK
  },
  mixins: [FN],
  data() {
    return {
        form:{
          phone: '',
          password: '',
          password2: '',
        }
    }
  },
  computed: {
    rules() {
        const message = '輸入不完整'
        // 自訂驗證-phone
        const isPhone = (rule, value, callback) => {
          const length = value.length
          if(!length){
            callback(new Error(message))
          }else if(length !== 10){
            callback(new Error('輸入錯誤，請輸入10位元電話號碼'))
          }else if(value.slice(0, 2) !== '09'){
            callback(new Error('輸入錯誤，請輸入09開頭之電話號碼'))
          }else{
            callback()
          }
        }
        // 自訂驗證-password
        const isPassword = (rule, value, callback) => {
          const length = value.length
          if(!length){
            callback(new Error(message))
          }else if(length < 8 || length > 14){
            callback(new Error('輸入錯誤，請輸入8-14位元'))
          }else{
            callback()
          }
        }
        // 自訂驗證-password2
        const isPassword2 = (rule, value, callback) => {
          const length = value.length
          if(!length){
            callback(new Error(message))
          }else if(value !== this.form.password){
            callback(new Error('兩次輸入的密碼不同'))
          }else{
            callback()
          }
        }
        return {
            phone: [
                { required: true, trigger: 'blur', validator: isPhone }
            ],
            password: [
                { required: true, trigger: 'blur', validator: isPassword },
                { type: 'string', pattern:'^[A-Za-z0-9]+$',message:'密碼限制使用英文或數字',trigger: 'blur'},
            ],
            password2: [
                { required: true, trigger: 'blur', validator: isPassword2 },
                { type: 'string', pattern:'^[A-Za-z0-9]+$',message:'密碼限制使用英文或數字',trigger: 'blur'},
            ]
        }
    },
    delayTimeText() {
      return this.delayText
    }
  },
  methods: {
    ...mapActions([
      'FETCH'
    ]),
    beforeHandleSubmit() {
      if(!this.delayCheck){
        this.$message({
          message: '請先獲取驗證碼',
          type: 'error'
        });
      }else{
        this.handleSubmit()
      }
    },
    //送出表單
    handleSubmit() {
      const form = this.$refs.form
      this.beforeValidate()
      form.validate((valid) => {
          if (valid) {
              this.loading = true
              this.beforeFormSubmit()
              this.FETCH({
                key: 'RESET_PASSWORD',
                phone: this.form.phone,
                password: this.form.password,
                code: this.form.vcode
              })
                .then((this.handleResponse))
          } else {
              this.loading = false
              this.handleUnValid()
          }
      })

    },
    //獲取驗證碼
    handleGetSMS() {
      const phone = this.form.phone
      if(phone !== '' && phone.slice(0, 2) === '09' && phone.length === 10){
        this.delayTime = true
        this.FETCH({
          key: 'FORGET_SMS',
          phone: this.form.phone
        }).then((res) =>{
          this.delayTime = false
          if(!+res.data.code) {
            this.delayCheck = this.delayCheck + 1
            this.throttle(30)
          }else{
            this.throttle(5)
          }
          this.$message({
            message: res.data.message,
            type: +res.data.code ? 'error' : 'success'
          });
        })
      }else{
        this.$message({
          message: '請輸入09開頭的有效手機號碼',
          type: 'error'
        });
      }
    },
    //回應
    handleResponse(res) {
      //避免殘留資訊先清空
      this.handleClearToken()
      if (!+res.code) {
        this.$confirm('密碼更改成功，請重新登入',{
          showCancelButton: false,
          type: 'success'
        })
          .then(() => {
            const { href } = this.$router.resolve({name: 'Login'})
            window.open(href, '_self')
          })
      }else{
        this.$confirm(res.message,{
          showCancelButton: false,
          type: 'error'
        })
      }
      this.loading = false
    },
    handleNoSMS() {
      this.$confirm('無法取得驗證碼請稍後或立即聯絡客服',{
        showCancelButton: false,
        confirmButtonText: '聯絡客服',
        type: '',
        center: true
      })
      .then(() => {
        window.location.href = 'tel://07010172077'
      })
    },
    handleBack() {
      const { href } = this.$router.resolve({name: 'Login'})
      window.open(href, '_self')
    }
  }
}
</script>
